<template>
    <Button
        label="Reenviar e-mail"
        class="p-button-primary mr-2"
        icon="pi pi-send"
        @click="confirmarReenviarEmail()"
        v-if="mostrarBtnExportar"
        :disabled="desabilitarBtn"
        aria-haspopup="true"
        aria-controls="overlay_menu"
    />
</template>

<script>
import services from './service';

export default {
    props: {
        produtoCheckoutsParaEnviarEmail: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {};
    },

    methods: {
        toggle(event) {
            this.$refs.menu.toggle(event);
        },
        confirmarReenviarEmail() {
            this.$confirm.require({
                message: `Tem certeza que reenviar email para os ${this.produtoCheckoutsParaEnviarEmail.length} links de pagamento?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.reenviarEmail();
                },
            });
        },
        reenviarEmail() {
            this.$store.dispatch('addRequest');
            const produtoCheckoutsParaEnviar = {
                produtoCheckoutsId: this.produtoCheckoutsParaEnviarEmail,
            };
            services.reenviarEmail(produtoCheckoutsParaEnviar).then((response) => {
                if (response?.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Emails reenviados',
                        detail: 'Os e-mails foram reenviados com sucesso',
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Emails reenviados',
                        detail: 'Falha ao reenviar os e-mails!',
                        life: 3000,
                    });
                }
                this.$emit('limparProdutoCheckoutsSelecionados');
                this.$store.dispatch('removeRequest');
            });
        },
    },

    computed: {
        mostrarBtnExportar() {
            return this.$temAcessoView('CHECKOUTS-PAGAMENTOS-06');
        },

        desabilitarBtn() {
            return !this.produtoCheckoutsParaEnviarEmail || this.produtoCheckoutsParaEnviarEmail.length === 0;
        },
    },
};
</script>
